import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  ActivityDeadlinesSortColumnEnum,
  BudgetSortColumnEnum,
  IBevarFilters,
  MeasuresSortColumnEnum,
  SortOrderEnum,
} from './filterModels'
import { RootState } from 'shared/store/store'
import { merge } from 'merge-anything'

const initialState = {
  activityDeadlinesFilters: {
    sortColumn: ActivityDeadlinesSortColumnEnum.nextDeadline,
    sortOrder: SortOrderEnum.Asc,
  } as IBevarFilters,
  budgetFilters: {
    sortColumn: BudgetSortColumnEnum.year,
    sortOrder: SortOrderEnum.Asc,
  } as IBevarFilters,
  measuresFilters: {
    sortColumn: MeasuresSortColumnEnum.performed,
    sortOrder: SortOrderEnum.Asc,
  } as IBevarFilters,
}

const bevarSlice = createSlice({
  name: 'bevar',
  initialState,
  reducers: {
    setActivityDeadlinesFilters: (
      state,
      action: PayloadAction<Partial<IBevarFilters>>
    ) => {
      state.activityDeadlinesFilters = merge(
        state.activityDeadlinesFilters,
        action.payload
      )
    },
    setBudgetFilters: (
      state,
      action: PayloadAction<Partial<IBevarFilters>>
    ) => {
      state.budgetFilters = merge(state.budgetFilters, action.payload)
    },
    setMeasuresFilters: (
      state,
      action: PayloadAction<Partial<IBevarFilters>>
    ) => {
      state.measuresFilters = merge(state.measuresFilters, action.payload)
    },
  },
})

export const getActivityDeadlinesFilters = (state: RootState) =>
  state.bevar.activityDeadlinesFilters

export const getBudgetFilters = (state: RootState) => state.bevar.budgetFilters

export const getMeasuresFilters = (state: RootState) =>
  state.bevar.measuresFilters

export const {
  setActivityDeadlinesFilters,
  setBudgetFilters,
  setMeasuresFilters,
} = bevarSlice.actions

export default bevarSlice
